import axios from 'axios';
import { attachLoader } from './siteLoader';
//require('dotenv').config({ path: `.env.${process.env.NODE_ENV}` })

var api_URL = 'http://localhost:7001'
if (process.env.NODE_ENV === "development") {
  api_URL = 'https://apiclient.newworld.center'
}
else if (process.env.NODE_ENV === "production") {
  api_URL = 'https://apiclient.newworld.center'
}
const instance = axios.create({
  baseURL: api_URL
});

// const instance = axios.create({
//     baseURL: 'http://localhost:7001'
// });
console.log(process.env.NODE_ENV);
const AUTH_TOKEN = "123"
const System = "Betner"
instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;

// [2026-11-04] หน้าโหลดโลโก้ตอนรอ API (src/siteLoader.js — แบบเดียวกับ starbet/bk8)
attachLoader(instance);

// ===== [2026-11-04] กันยิง API ซ้ำ (เว็บนี้มีหลายส่วนแยกกัน: App / หน้าหลัก / sidebar ต่างคนต่างโหลดเอง) =====
//   - ยิงพร้อมกันหลายที่ด้วยค่าเดียวกัน = ยิงจริงครั้งเดียว ทุกที่ได้ผลเดียวกัน
//   - ข้อมูลที่ไม่ค่อยเปลี่ยน (ตั้งค่าเว็บ / แบนเนอร์ / โปรโมชั่น ...) จำไว้สั้น ๆ ไม่ยิงซ้ำ
//   - เดิมเปิดหน้าเดียวยิง mainsetting ~5 ครั้ง, checkpoint ~4 ครั้ง, saveclick 2 ครั้ง (นับคลิกลิงก์แนะนำซ้ำ)
const _DEDUPE_RULES = [
  { re: /\/api\/v1\/mainsetting\b/, ttl: 60000, key: (d) => (d && d.System) + '|' + ((d && d.Playerid) || '') },
  { re: /\/api\/v1\/checkpoint\b/, ttl: 2000, key: (d) => (d && d.userid) + '|' + (d && d.System) }, // ไม่สน Function (แต่ละไฟล์ใส่ชื่อต่างกัน)
  { re: /\/api\/v1\/(getthemesv|tabbannerlist|popuplist|cacheversion|tabgamelistpop|getwheelspin|gettrue)\b/, ttl: 60000 },
  { re: /\/api\/v1\/getpromotion\b/, ttl: 15000 }, // รายการโปร (มีสถานะผู้เล่น) จำสั้น ๆ พอกันยิงซ้ำตอนเปิดหน้า
  { re: /\/api\/v1\/(checkuseradvice|getcheckin)\b/, ttl: 15000 },
  { re: /\/api\/v1\/rewardlist\b/, ttl: 15000 },
  { re: /\/api\/v1\/(saveclick|saveclickaff)\b/, ttl: 10000 },
];
const _dedupeInflight = new Map();
const _dedupeCache = new Map();
function _dedupeRule(url) { const u = String(url || ''); return _DEDUPE_RULES.find((r) => r.re.test(u)); }
function _dedupeWrap(method, orig) {
  return function (url, a, b) {
    const rule = _dedupeRule(url);
    if (!rule) return orig.call(instance, url, a, b);
    const data = method === 'get' ? (a && a.params) : a;
    let k;
    try { k = method + ' ' + String(url).split('?')[0] + ' ' + (rule.key ? rule.key(data || {}) : String(url) + JSON.stringify(data || {})); } catch (e) { return orig.call(instance, url, a, b); }
    const c = _dedupeCache.get(k);
    if (c && Date.now() - c.t < rule.ttl) return Promise.resolve(c.res);
    if (_dedupeInflight.has(k)) return _dedupeInflight.get(k);
    const p = orig.call(instance, url, a, b).then((res) => {
      _dedupeInflight.delete(k);
      if (res && res.data && (res.data.status === 200 || /saveclick/.test(String(url)))) _dedupeCache.set(k, { t: Date.now(), res });
      return res;
    }, (err) => { _dedupeInflight.delete(k); throw err; });
    _dedupeInflight.set(k, p);
    return p;
  };
}
instance.post = _dedupeWrap('post', instance.post);
instance.get = _dedupeWrap('get', instance.get);
// หลังล็อกอิน/ออกจากระบบ/ฝาก-ถอน อยากได้ข้อมูลใหม่ทันที: เรียก instance.clearApiCache()
instance.clearApiCache = () => { _dedupeCache.clear(); };

export default instance;

